import styled from "styled-components";
import Modal from "react-modal";

export const ModalContainer = styled(Modal)`
  /* Estilos customizados aplicados via prop style no componente */
`;

export const ModalContent = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-sizing: border-box;
`;

export const ModalHeader = styled.div`
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8787 100%);
  color: #ffffff;
  padding: 24px;
  text-align: center;
  
  h2 {
    margin: 8px 0 0 0;
    font-size: 20px;
    font-weight: 600;
  }
`;

export const WarningIcon = styled.div`
  font-size: 48px;
  line-height: 1;
`;

export const ModalBody = styled.div`
  padding: 24px;
  box-sizing: border-box;
  
  label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 8px;
  }
`;

export const MessageText = styled.p`
  font-size: 15px;
  color: #555555;
  line-height: 1.6;
  margin-bottom: 20px;
  text-align: left;
`;

export const ReasonInput = styled.textarea`
  width: 100%;
  padding: 12px;
  font-size: 14px;
  border: 2px solid ${props => props.hasError ? "#ff6b6b" : "#dddddd"};
  border-radius: 8px;
  resize: vertical;
  font-family: inherit;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? "#ff6b6b" : "#4a90e2"};
  }
  
  &::placeholder {
    color: #999999;
  }
  
  &:read-only {
    cursor: pointer;
    background-color: #ffffff;
  }
`;

export const ErrorText = styled.div`
  color: #ff6b6b;
  font-size: 13px;
  margin-top: 8px;
  font-weight: 500;
`;

export const CharCounter = styled.div`
  font-size: 12px;
  text-align: right;
  margin-top: 4px;
  color: ${props => props.$isInvalid ? "#ff6b6b" : "#666666"};
  font-weight: ${props => props.$isInvalid ? 600 : 400};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const CancelButton = styled.button`
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  color: #666666;
  background-color: #f0f0f0;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #e0e0e0;
    border-color: #d0d0d0;
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

export const ConfirmButton = styled.button`
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8787 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: linear-gradient(135deg, #ff5252 0%, #ff6b6b 100%);
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
  }
  
  &:active {
    transform: scale(0.98);
  }
`;
